// hooks/useUrlValidation.ts
import { useState, useCallback } from 'react';
import { ValidationResult } from '../types';
import { getIssueByUrl } from '../../../../gitlabApi/gqlApi/getIssueByUrl';

interface UseUrlValidationReturn {
  validateUrl: (url: string) => Promise<ValidationResult>;
  isValidating: boolean;
  error: string | null;
}

export const useUrlValidation = (): UseUrlValidationReturn => {
  const [isValidating, setIsValidating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const validateUrl = useCallback(async (url: string): Promise<ValidationResult> => {
    setIsValidating(true);
    setError(null);

    try {
      // URL валидация с использованием regex
      const urlRegex =
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;

      if (!urlRegex.test(url)) {
        throw new Error('Неверный формат URL');
      }

      const issue = await getIssueByUrl({ url });
      if (!issue) throw new Error('Не удалось получить информацию о задаче');

      return {
        name: issue.title,
        slug: issue.id,
        webPath: issue.webUrl, // возвращаем оригинальный URL как webPath
        projectName: issue.project.name,
      };
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Ошибка валидации URL';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsValidating(false);
    }
  }, []);

  return { validateUrl, isValidating, error };
};
